/**
 * caminhoSeguroInterno — parte C (30/09/2026).
 *
 * O `link` de uma notificação de colaborador (o sino e o "Ver todas") vem do
 * backend, montado de uma lista fechada (`notification_links.py`). Antes de
 * navegar, a mesma defesa em profundidade do `caminhoSeguroDoPortal`:
 * `new URL(link, origem)` resolve `..` e `//host` ANTES de comparar, e só sobra
 * caminho da MESMA origem. O portal do parceiro (`/portal`) fica de fora: não é
 * destino de notificação de colaborador.
 *
 * Devolve `pathname + search + hash` (o que o `navigate()` precisa) ou `null`.
 */
export function caminhoSeguroInterno(link?: string | null): string | null {
  if (!link) return null;

  // Antes de resolver: só caminho que começa com UMA `/`, sem `\` (o parser da URL
  // trata `\` como `/`, e `/\evil.com` vira `//evil.com`).
  if (!link.startsWith("/") || link.startsWith("//") || link.includes("\\")) return null;

  let url: URL;
  try {
    url = new URL(link, window.location.origin);
  } catch {
    return null;
  }

  if (url.origin !== window.location.origin) return null;
  // Depois de resolver: o ponto esconde o `//host` (`/.//evil.com` resolve para o
  // pathname `//evil.com`); o `pushState` com isso lança SecurityError e o router
  // cai no `window.location.assign`, que tira a pessoa do site.
  if (url.pathname.startsWith("//")) return null;
  if (url.pathname === "/portal" || url.pathname.startsWith("/portal/")) return null;

  return `${url.pathname}${url.search}${url.hash}`;
}
